"use client";

import { SharedConfig } from "@shared/lib/config";
import { User } from "@shared/naco";
import { createContext, useEffect } from "react";
import { initAlgoliaInsights } from "./libs";

const AlgoliaInsightsServiceProviderContext = createContext<SharedConfig | null>(null);

export function AlgoliaInsightsServiceProvider({
  config,
  nacoUser,
  children,
}: {
  children: React.ReactNode;
  nacoUser: User;
  config: SharedConfig;
}) {
  useEffect(() => {
    if (config && config.algolia && nacoUser) {
      initAlgoliaInsights({
        appId: config.algolia.applicationId,
        apiKey: config.algolia.searchApiKey,
        host: config.algolia.host ? "https://" + config.algolia.host : undefined,
        otherOptions: nacoUser
          ? {
              userToken: `user-${nacoUser?.id}`,
            }
          : undefined,
      });
    }
  }, []);

  return (
    <AlgoliaInsightsServiceProviderContext.Provider
      value={{
        ...config,
      }}
    >
      {children}
    </AlgoliaInsightsServiceProviderContext.Provider>
  );
}
